import { render } from "./FacilitiesList.vue?vue&type=template&id=1406bff7"
import script from "./FacilitiesList.vue?vue&type=script&lang=js"
export * from "./FacilitiesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__